<div class="css-Boton_Secundario-1 boton_secundario">
  <button
    type="button"
    class="css-button_Icono_Izquierda_Secundario-1 button_icono_izquierda_secundario"
    (click)="ejecutarFuncion()"
  >
    <div class="icono_consultenos">
      <img
        src="assets/images/basecomponents-images/icono-correo.svg"
        width="17.5px"
        height="15.833343505859px"
        data-wcfid="vector_forwardtoinbox"
        original-id="5236:14713"
        data-name="vector-forwardtoinbox"
        class="css-Vector_forward_to_inbox vector_forwardtoinbox"
      />
    </div>
    <p class="css-Texto_1-1 texto_1">{{ boton_texto }}</p>
  </button>
  <p class="css-Estado-2 estado" *ngIf="estado">{{ estado }}</p>
</div>
